export const SUBSCRIBE_CHANNEL_PROGRESS = "SUBSCRIBE_CHANNEL_PROGRESS";
export const SUBSCRIBE_CHANNEL_SUCCESS = "SUBSCRIBE_CHANNEL_SUCCESS";
export const SUBSCRIBE_CHANNEL_ERROR = "SUBSCRIBE_CHANNEL_ERROR";

export const UNSUBSCRIBE_CHANNEL_PROGRESS = "UNSUBSCRIBE_CHANNEL_PROGRESS";
export const UNSUBSCRIBE_CHANNEL_SUCCESS = "UNSUBSCRIBE_CHANNEL_SUCCESS";
export const UNSUBSCRIBE_CHANNEL_ERROR = "UNSUBSCRIBE_CHANNEL_ERROR";

export const GET_INFORMATION_CHANNEL_PROGRESS = "GET_INFORMATION_CHANNEL_PROGRESS";
export const GET_INFORMATION_CHANNEL_SUCCESS = "GET_INFORMATION_CHANNEL_SUCCESS";
export const GET_INFORMATION_CHANNEL_ERROR = "GET_INFORMATION_CHANNEL_ERROR";

export const GET_CHANNEL_PROGRESS = "GET_CHANNEL_PROGRESS";
export const GET_CHANNEL_SUCCESS = "GET_CHANNEL_SUCCESS";
export const GET_CHANNEL_ERROR = "GET_CHANNEL_ERROR";

export const GET_ITEMS_CHANNEL_PROGRESS = "GET_ITEMS_CHANNEL_PROGRESS";
export const GET_ITEMS_CHANNEL_SUCCESS = "GET_ITEMS_CHANNEL_SUCCESS";
export const GET_ITEMS_CHANNEL_ERROR = "GET_ITEMS_CHANNEL_ERROR";

export const REFRESH_DATA_CHANNEL_PROGRESS = "REFRESH_DATA_CHANNEL_PROGRESS";
export const REFRESH_DATA_CHANNEL_SUCCESS = "REFRESH_DATA_CHANNEL_SUCCESS";
export const REFRESH_DATA_CHANNEL_ERROR = "REFRESH_DATA_CHANNEL_ERROR";

export const GET_ATTACHMENTS_CHANNEL_PROGRESS = "GET_ATTACHMENTS_CHANNEL_PROGRESS";
export const GET_ATTACHMENTS_CHANNEL_SUCCESS = "GET_ATTACHMENTS_CHANNEL_SUCCESS";
export const GET_ATTACHMENTS_CHANNEL_ERROR = "GET_ATTACHMENTS_CHANNEL_ERROR";

export const GET_URL_ATTACHMENTS_PROGRESS = "GET_URL_ATTACHMENTS_PROGRESS";
export const GET_URL_ATTACHMENTS_SUCCESS = "GET_URL_ATTACHMENTS_SUCCESS";
export const GET_URL_ATTACHMENTS_ERROR = "GET_URL_ATTACHMENTS_ERROR";

export const GET_IMAGES_PROGRESS = "GET_IMAGES_PROGRESS";
export const GET_IMAGES_SUCCESS = "GET_IMAGES_SUCCESS";
export const GET_IMAGES_ERROR = "GET_IMAGES_ERROR";

export const GET_URL_LIST_PROGRESS = "GET_URL_LIST_PROGRESS";
export const GET_URL_LIST_SUCCESS = "GET_URL_LIST_SUCCESS";
export const GET_URL_LIST_ERROR = "GET_URL_LIST_ERROR";

export const CLEAR_ERROR_MESSAGE= "CLEAR_ERROR_MESSAGE";
export const CLEAR_CHANNEL= "CLEAR_CHANNEL";